
const teamTypes = {
	TEAM: "TEAM",
	ONE_ON_ONE: "ONE_ON_ONE",
};

export default Object.freeze( teamTypes );



// WEBPACK FOOTER //
// ./src/constants/TeamType.js